import React from 'react';
import { BasicForm, notification, showInformationDialog, Typography } from 'ui-lib';
import { TextFieldItem, IconTextButton, SimpleFileUploadItem, useForm, } from 'ui-lib';
import fileTransferCss from './new-file-transfer.css';
import { useAuthStore, useStores, useUploadFilesStore } from 'store';
import { useSimpleFileUploadProps } from 'ui-lib/components/forms/items/use-simple-file-upload-item';
import { getErrorMessage } from 'common-utils';
import { confirmAction } from 'pages/private/admin/utils';

interface IUploadFileProps {
    selectedClientAccountId: number;
    onCancel?: () => void;
}

export const UploadFile = (props: IUploadFileProps) => {
    const [form] = useForm();
    const uploadFilesStore = useUploadFilesStore();
    const simpleFileUploadProps = useSimpleFileUploadProps({
        multiple: false,
        uploadButton: { label: 'Select File To Upload', type: 'primary' },
    });

    const [description, setDescription] = React.useState('');

    const uploadFile = async (values: any) => {
        try {
            if (simpleFileUploadProps.files.length === 0) {
                return showInformationDialog({
                    modalType: 'error',
                    title: 'Upload File Error',
                    content: `please choose file`,
                });
            }
            const result = await uploadFilesStore.uploadFile(
                props.selectedClientAccountId,
                {
                    description: description,
                },
                simpleFileUploadProps.files.length > 0 ? simpleFileUploadProps.files[0] : undefined
            );

            if (result) {
                notification.success({
                    message: 'File Successfully Uploaded',
                    description: `File ${result.fileName} has been uploaded.`,
                });
                props.onCancel();
            }

            simpleFileUploadProps.setFiles([]);

        } catch (err) {
            notification.error({
                message: getErrorMessage(err),
                placement: 'topRight',
            });
        }
    };

    const handleSubmit = (values: any) => {
        confirmAction(values, 'Upload File', 'Do you want to upload this file?', uploadFile);
    };

    return (
        <React.Fragment>
            <Typography.Title level={2}>Upload New File</Typography.Title>
            <BasicForm
                title='Upload New File'
                form={form}
                onSubmit={handleSubmit}
                className={fileTransferCss['transfer-form']}
                items={[
                    <TextFieldItem
                        initialValue={description}
                        key='description'
                        code='description'
                        label='Description'
                        colon={true}
                        isRequired={false}
                        labelAlign='right'
                        onChange={(value) => setDescription(value.target.value)}
                    />,
                    <SimpleFileUploadItem
                        key='fileUpload'
                        simpleFileUploadProps={simpleFileUploadProps.getFileUploadProps()}
                        code='fileUpload'
                        label=' '
                    />,
                    <div className={fileTransferCss['row']}>
                        <IconTextButton
                            key='back-button'
                            className={fileTransferCss['footer-left-button']}
                            htmlType='button'
                            label='Back'
                            onClick={props.onCancel}
                        />
                        <IconTextButton
                            key='upload-submit-button'
                            className={fileTransferCss['footer-right-button']}
                            htmlType='submit'
                            label='Upload'
                            type='primary'
                            disabled={!simpleFileUploadProps.files.length || simpleFileUploadProps.hasFileError}
                        />
                    </div>,
                ]}
            />
        </React.Fragment>
    );
};

